import { lazy } from 'react';

export const PlayerRequestDocumentsForm = lazy(
  () => import('./PlayerRequestDocumentsForm'),
);
